import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {DasUBootGameData} from "./server/DasUBootData";
import {DasUBootGameMode} from "./server/DasUBootGameMode";
import {DasUBootSound} from "./sound/DasUBootSound";
import {DasUBoot} from "./DasUBoot";



export class DasXBootPromoPanelConfig implements PromoPanelGameConfiguration{

    constructor() {}

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Das xBoot",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: DasUBootGameData, bet: number, prevResponse: DasUBootGameData):ASWinData => {
                if (response.mode == DasUBootGameMode.NORMAL) {
                    this.lastUsedFeatureName = "";
                }
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: +response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit:  response.accumulatedRoundWin / response.playedBetValue >= 55200,
                }
                return parsedData;
            }
        };
    }

    private isFreeSpinTriggered(response: DasUBootGameData): boolean {
        return response.freespinTriggeredThisSpin === true; //(response.mode === TombstoneRipGameMode.NORMAL) && response.nextMode === TombstoneRipGameMode.FREESPIN;
    }

    private isBigWin(response:DasUBootGameData): boolean {
        let win = response.totalSpinWinnings;

        if (response.wasFeatureBuy){
            const betPrice = DasUBoot.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private lastUsedFeatureName = "";
    private getFeatureName(response: DasUBootGameData): string {

        if ((response.mode == DasUBootGameMode.FREESPIN) || response.nextMode == DasUBootGameMode.FREESPIN){
            this.lastUsedFeatureName = "SILENT HUNTER SPINS"
        }

        if ((response.mode == DasUBootGameMode.SUPER_FREESPIN) || response.nextMode == DasUBootGameMode.SUPER_FREESPIN){
            this.lastUsedFeatureName = "WOLF PACK SPINS";
        }


        return this.lastUsedFeatureName;
    }

    private isRoundComplete(response: DasUBootGameData): boolean {
        const compl = ([DasUBootGameMode.FREESPIN,DasUBootGameMode.SUPER_FREESPIN, DasUBootGameMode.NORMAL].indexOf(response.nextMode) > -1);
        return  compl;
    }

    private isBonusEnd(response: DasUBootGameData): boolean {
        return (response.nextMode === DasUBootGameMode.NORMAL) && (response.mode === DasUBootGameMode.FREESPIN || response.mode === DasUBootGameMode.SUPER_FREESPIN);
    }

    public isLegalStopOnBonusMode(data:IResponseData){
        if ((data.nextMode==DasUBootGameMode.FREESPIN || data.nextMode==DasUBootGameMode.SUPER_FREESPIN )&& (data.mode == DasUBootGameMode.NORMAL || data.mode == DasUBootGameMode.AVALANCHE)){
            return true;
        }
        return false;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN){
            DasUBoot.soundPlayer.playSound( DasUBootSound.AS_WIN)
        }
        else if (trigger == ActionSpinSound.BIG_WIN) {
            DasUBoot.soundPlayer.playSound( DasUBootSound.AS_WIN_BIG)
        }

    }

}